<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ classificacao.classificacao_id ? "Editar" : "Nova" }}
                Classificação
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="Name">
                          <span class="required">*</span> Cor:
                        </label>
                        <input type="color" class="form-control" v-model="classificacao.cor" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Name">
                          Descrição:
                        </label>
                        <input type="text" class="form-control" v-model="classificacao.descricao" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Name"> Status: </label>
                        <select v-model="classificacao.status" class="form-control">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Name"> Classificação em alerta : </label>
                        <select v-model="classificacao.alerta" class="form-control" :true-value="true"
                          :false-value="false">
                          <option :value="true">Ativo</option>
                          <option :value="false">Inativo</option>
                        </select>
                      </div>
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/classificacoes" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      classificacao: {
        cor: "",
        status: 1,
        alerta: false,
      },

      previewImage: null,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "classificacoes";

      if (self.classificacao.id) {
        self.classificacao._method = "PUT";
        api += "/" + self.classificacao.id;
      }

      axios
        .post(api, self.classificacao)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/classificacoes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClassificacao: function (id) {
      const self = this;
      const api = self.$store.state.api + "classificacoes/" + id;

      axios
        .get(api)
        .then((response) => {
          self.classificacao = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.change_password = false;
      self.getClassificacao(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>